<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             ok-only
             :ok-text="$t('common.share')"
             :ok-disabled="archivesStore.getArchiveRightsPending"
             :ok-loading="archivesStore.shareArchivesPending"
             @cancel="closeDialog"
             @ok="share"
  >
    <template #title>{{ $t('archives.dialogs.ArchivesShareDialog.title') }}</template>

    <template #body>
      <p v-t="{
           path: 'archives.dialogs.ArchivesShareDialog.subtitle',
           plural: archivesStore.selectedDocuments.length - 1,
           args: { name: archivesStore.selectedDocuments[0].docName },
         }"
         class="text-text-secondary mb-4"
      />

      <ArchivesShareModule
        v-if="!archivesStore.getArchiveRightsPending"
        v-model:value="shareConfig"
      />
      <div v-else class="text-center">
        <v-progress-circular
          style="width: 64px; height: 64px"
          indeterminate
          size="64"
        />
      </div>
    </template>
  </app-modal>
</template>

<script>
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { useArchivesStore } from '@/stores/archivesStore'

import ArchivesShareModule from '../ArchivesShareModule.vue'

export default {
  name: 'ArchivesShareDialog',
  components: { ArchivesShareModule },
  mixins: [dialogMixin],
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  props: {},
  data () {
    return {
      shareConfig: {
        fileRights: [],
        notifyMessage: '',
        notify: false,
      },
    }
  },
  async created () {
    // If there is only one archive to share, we will get its initial config
    if (this.archivesStore.selectedDocuments.length === 1) {
      await this.archivesStore.getArchiveRights(this.archivesStore.selectedDocuments[0].id)
      this.shareConfig.fileRights = this.archivesStore.currentArchiveRights.read.users.map((u) => u.id)
    }
  },
  methods: {
    async share () {
      const formData = new FormData()
      formData.append('withUsers', this.shareConfig.fileRights)
      formData.append('notify', this.shareConfig.notify)
      formData.append('notifyMessage', this.shareConfig.notifyMessage)
      formData.append('archives', this.archivesStore.selectedDocuments.map((a) => a.id))
      await this.archivesStore.shareArchives(formData)
      toast.success(this.$t('archives.dialogs.ArchivesShareDialog.success', this.archivesStore.selectedDocuments.length))
      this.closeDialog()
    },
  },
}
</script>
